export default __webpack_public_path__ + "static/handbook-3b173af1ceca5a7dd51d335ae8fb747f.jpg";